module.exports = __webpack_public_path__ + "media/images/front/icons/products-07d668f2a00019c3069acfed498cd63e.png";